// extracted by mini-css-extract-plugin
module.exports = {"container":"DynamicLink_container__3tFqs","link":"DynamicLink_link__11IQe","label":"DynamicLink_label__l_oqv"};